import {
  GET_LOYALTY_LIST,
  GET_LOYALTY_LIST_SUCCESS,
  GET_LOYALTY_LIST_ERROR,
  LOYALTY_SINGLE_CUSTOMER_DATA,
  LOYALTY_SINGLE_CUSTOMER_DATA_SUCCESS,
  LOYALTY_SINGLE_CUSTOMER_DATA_ERROR,
  LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH,
  LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_SUCCESS,
  LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_ERROR,
  GET_LOYALTY_BALANCES_LIST,
  GET_LOYALTY_BALANCES_LIST_SUCCESS,
  GET_LOYALTY_BALANCES_LIST_ERROR,
  GET_LOYALTY_VOUCHERS_LIST,
  GET_LOYALTY_VOUCHERS_LIST_SUCCESS,
  GET_LOYALTY_VOUCHERS_LIST_ERROR,
  GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST,
  GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_ERROR,
  SEARCH_LOYALTY_DASHBOARD_REPORT_DATA,
  SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_SUCCESS,
  SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_ERROR,
  CREATE_LOYALTY_TRANSACTION,
  CREATE_LOYALTY_TRANSACTION_SUCCESS,
  CREATE_LOYALTY_TRANSACTION_ERROR,
  CREATE_LOYALTY_VOUCHER_AMOUNT,
  CREATE_LOYALTY_VOUCHER_AMOUNT_SUCCESS,
  CREATE_LOYALTY_VOUCHER_AMOUNT_ERROR,
  LOYALTY_REDEEM_VOUCHER,
  LOYALTY_REDEEM_VOUCHER_SUCCESS,
  LOYALTY_REDEEM_VOUCHER_ERROR,
  VOID_VOUCHER_TRANSACTION,
  VOID_VOUCHER_TRANSACTION_SUCCESS,
  VOID_VOUCHER_TRANSACTION_ERROR,
  RESEND_LOYALTY_VOUCHER_EMAIL,
  RESEND_LOYALTY_VOUCHER_EMAIL_SUCCESS,
  RESEND_LOYALTY_VOUCHER_EMAIL_ERROR,
  LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST,
  LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_SUCCESS,
  LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_ERROR,
  GET_LOYALTY_SPINNER_LIST,
  GET_LOYALTY_SPINNER_LIST_SUCCESS,
  GET_LOYALTY_SPINNER_LIST_ERROR,
  CREATE_LOYALTY_SPINNER,
  CREATE_LOYALTY_SPINNER_SUCCESS,
  CREATE_LOYALTY_SPINNER_ERROR,
  UPDATE_LOYALTY_SPINNER,
  UPDATE_LOYALTY_SPINNER_SUCCESS,
  UPDATE_LOYALTY_SPINNER_ERROR,
  DELETE_LOYALTY_SPINNER,
  DELETE_LOYALTY_SPINNER_SUCCESS,
  DELETE_LOYALTY_SPINNER_ERROR,
  GET_LOYALTY_SPINNER_RENDER,
  GET_LOYALTY_SPINNER_RENDER_SUCCESS,
  GET_LOYALTY_SPINNER_RENDER_ERROR,
  GET_LOYALTY_SPINNER_DATA,
  GET_LOYALTY_SPINNER_DATA_SUCCESS,
  GET_LOYALTY_SPINNER_DATA_ERROR,
  EXECUTE_LOYALTY_SPINNER,
  EXECUTE_LOYALTY_SPINNER_SUCCESS,
  EXECUTE_LOYALTY_SPINNER_ERROR,
} from "./actionType";

// Initial State
const initialState = {
  loyaltyList: [],
  loading: false,
  error: null,
  loyaltySingleCustomerData: [],
  loyaltySingleCustomerBalanceData: [],
  loyaltyBalancesList: [],
  loyaltyVouchersList: [],
  loyaltyDashboardActivityList: [],
  loyaltyDashboardReportData: [],
  loadingLoyaltyDashboardReportData: false,
  loyaltyRedeemVoucherResponse: [],
  voidVoucherTransactionResponse: [],
  resendLoyaltyVoucherEmailResponse: [],
  resendLoyaltyVoucherEmailLoading: false,
  loyaltySingleCustomerVoucherList: [],
  loyaltyTransactionCreatedSuccess: [],
  loyaltyVoucherCreatedResponseSuccess: [],
  loyaltySpinnerList: [],
  loyaltySpinnerCreatedResponse: [],
  loyaltySpinnerUpdatedResponse: [],
  loyaltySpinnerDeletedResponse: [],
  loyaltySpinnerRenderData: [],
  loyaltySpinnerData: [],
  loyaltySpinnerExecutedResponse: [],
};

// Reducer

const Loyalty = (state = initialState, action) => {
  switch (action.type) {
    case GET_LOYALTY_LIST:
      return {
        ...state,
        loading: true,
      };
    case GET_LOYALTY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltyList: action.payload,
      };
    case GET_LOYALTY_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LOYALTY_SINGLE_CUSTOMER_DATA:
      return {
        ...state,
        loading: true,
        loyaltySingleCustomerData: action.payload,
      };
    case LOYALTY_SINGLE_CUSTOMER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltySingleCustomerData: action.payload,
      };
    case LOYALTY_SINGLE_CUSTOMER_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH:
      return {
        ...state,
        loading: true,
        loyaltySingleCustomerBalanceData: action.payload,
      };
    case LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltySingleCustomerBalanceData: action.payload,
      };
    case LOYALTY_SINGLE_CUSTOMER_BALANCE_SEARCH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_LOYALTY_BALANCES_LIST:
      return {
        ...state,
        loading: true,
      };
    case GET_LOYALTY_BALANCES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltyBalancesList: action.payload,
      };

    case GET_LOYALTY_BALANCES_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_LOYALTY_VOUCHERS_LIST:
      return {
        ...state,
        loading: true,
      };
    case GET_LOYALTY_VOUCHERS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltyVouchersList: action.payload,
      };
    case GET_LOYALTY_VOUCHERS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST:
      return {
        ...state,
        loading: true,
      };
    case GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltyDashboardActivityList: action.payload,
      };
    case GET_LOYALTY_DASHBOARD_RECENT_ACTIVITY_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SEARCH_LOYALTY_DASHBOARD_REPORT_DATA:
      return {
        ...state,
        loadingLoyaltyDashboardReportData: true,
      };
    case SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_SUCCESS:
      return {
        ...state,
        loadingLoyaltyDashboardReportData: false,
        loyaltyDashboardReportData: action.payload,
      };
    case SEARCH_LOYALTY_DASHBOARD_REPORT_DATA_ERROR:
      return {
        ...state,
        loadingLoyaltyDashboardReportData: false,
        error: action.payload,
      };

    case CREATE_LOYALTY_TRANSACTION:
      return {
        ...state,
        loading: true,
      };
    case CREATE_LOYALTY_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltyTransactionCreatedSuccess: action.payload,
      };

    case CREATE_LOYALTY_TRANSACTION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_LOYALTY_VOUCHER_AMOUNT:
      return {
        ...state,
        loading: true,
      };
    case CREATE_LOYALTY_VOUCHER_AMOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltyVoucherCreatedResponseSuccess: action.payload,
      };
    case CREATE_LOYALTY_VOUCHER_AMOUNT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LOYALTY_REDEEM_VOUCHER:
      return {
        ...state,
        loading: true,
      };
    case LOYALTY_REDEEM_VOUCHER_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltyRedeemVoucherResponse: action.payload,
      };
    case LOYALTY_REDEEM_VOUCHER_ERROR:
      return {
        ...state,
        loading: false,
      };

    case VOID_VOUCHER_TRANSACTION:
      return {
        ...state,
        loading: true,
      };
    case VOID_VOUCHER_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        voidVoucherTransactionResponse: action.payload,
      };
    case VOID_VOUCHER_TRANSACTION_ERROR:
      return {
        ...state,
        loading: false,
      };

    case RESEND_LOYALTY_VOUCHER_EMAIL:
      return {
        ...state,
        resendLoyaltyVoucherEmailLoading: true,
      };
    case RESEND_LOYALTY_VOUCHER_EMAIL_SUCCESS:
      return {
        ...state,
        resendLoyaltyVoucherEmailResponse: action.payload,
        resendLoyaltyVoucherEmailLoading: false,
      };
    case RESEND_LOYALTY_VOUCHER_EMAIL_ERROR:
      return {
        ...state,
        resendLoyaltyVoucherEmailLoading: false,
      };

    case LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST:
      return {
        ...state,
      };

    case LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_SUCCESS:
      return {
        ...state,
        loyaltySingleCustomerVoucherList: action.payload,
      };

    case LOYALTY_SINGLE_CUSTOMER_VOUCHER_LIST_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LOYALTY_SPINNER_LIST:
      return {
        ...state,
        loading: true,
      };
    case GET_LOYALTY_SPINNER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltySpinnerList: action.payload,
      };
    case GET_LOYALTY_SPINNER_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_LOYALTY_SPINNER:
      return {
        ...state,
        loading: true,
      };
    case CREATE_LOYALTY_SPINNER_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltySpinnerCreatedResponse: action.payload,
      };
    case CREATE_LOYALTY_SPINNER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LOYALTY_SPINNER:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_LOYALTY_SPINNER_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltySpinnerUpdatedResponse: action.payload,
      };
    case UPDATE_LOYALTY_SPINNER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LOYALTY_SPINNER:
      return {
        ...state,
        loading: true,
      };
    case DELETE_LOYALTY_SPINNER_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltySpinnerDeletedResponse: action.payload,
      };
    case DELETE_LOYALTY_SPINNER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_LOYALTY_SPINNER_RENDER:
      return {
        ...state,
        loading: true,
      };
    case GET_LOYALTY_SPINNER_RENDER_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltySpinnerRenderData: action.payload,
      };
    case GET_LOYALTY_SPINNER_RENDER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_LOYALTY_SPINNER_DATA:
      return {
        ...state,
        loading: true,
      };
    case GET_LOYALTY_SPINNER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltySpinnerData: action.payload,
      };
    case GET_LOYALTY_SPINNER_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case EXECUTE_LOYALTY_SPINNER:
      return {
        ...state,
        loading: true,
      };
    case EXECUTE_LOYALTY_SPINNER_SUCCESS:
      return {
        ...state,
        loading: false,
        loyaltySpinnerExecutedResponse: action.payload,
      };
    case EXECUTE_LOYALTY_SPINNER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Loyalty;
